/* @flow */
import * as React from 'react';

import { Roles } from 'user/UserConstants';
import { withRouter } from 'app/context/Router';
import AppleImage from 'assets/images/apple.svg';
import BellImage from 'assets/images/bell.svg';
import BoxSelect from 'components/BoxSelect';
import BoxSelectItem from 'components/BoxSelectItem';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import Container from 'components/Container';
import HeartImage from 'assets/images/heart.svg';
import PencilImage from 'assets/images/pencil.svg';

type Props = {
  onSelect: (role: string) => void,
  router: *,
  showAdminOption: ?boolean,
  loading: ?boolean,
};

class RolePickerForm extends React.Component<Props, *> {
  render() {
    if (this.props.loading) {
      return <CenteredLoadingIndicator />;
    }

    return (
      <Container size="medium">
        <BoxSelect title="Tell us about yourself">
          <BoxSelectItem
            data-test="teacher-role"
            border
            label="I’m a teacher"
            className="RolePicker-button--teacher"
            eventElementName="RolePicker-button--teacher"
            icon={AppleImage}
            action={() => this.props.onSelect(Roles.teacher)}>
            Teacher, coach, club adviser, organizer, etc.
          </BoxSelectItem>
          <BoxSelectItem
            data-test="student-role"
            border
            label="I’m a student"
            className="RolePicker-button--student"
            eventElementName="RolePicker-button--student"
            icon={PencilImage}
            action={() => this.props.onSelect(Roles.student)}>
            Student in a class, member of a sports team, club participant, etc.
          </BoxSelectItem>
          <BoxSelectItem
            data-test="parent-role"
            border
            label="I’m a parent"
            className="RolePicker-button--parent"
            eventElementName="RolePicker-button--parent"
            icon={HeartImage}
            action={() => this.props.onSelect(Roles.parent)}>
            Parent or guardian
          </BoxSelectItem>
          {this.props.showAdminOption && (
            <BoxSelectItem
              data-test="admin-role"
              border
              label="I’m an administrator"
              className="RolePicker-button--admin"
              eventElementName="RolePicker-button--admin"
              icon={BellImage}
              action={() => this.props.router.push('/setup/admin_role')}>
              Superintendent, principal, tech coordinator, etc.
            </BoxSelectItem>
          )}
        </BoxSelect>
      </Container>
    );
  }
}

export { RolePickerForm };

export default withRouter(RolePickerForm);
